<template>
  <div class="search-content top-computed-ele g-flex">
    <div class="__main g-flex g-flex__flex1">
      <div class="g-flex__flex1">
        <div :class="{'up':!show}">
          <slot />
        </div>
      </div>
    </div>
    <div
      v-show="showDropDown"
      class="__arrow"
      @click="handleHide"
    >
      <img
        :class="{'noRotate': show}"
        src="../../assets/img/icon/jt_gray.png"
      >
    </div>
  </div>
</template>

<script>
  import emitter from '../../mixins/emitter.js';

  export default {
    name: 'search-content',
    mixins: [emitter],
    data() {
      return {
        show: true
      };
    },
    props: {
      showDropDown: {
        type: Boolean,
        default: true
      }
    },
    methods: {
      handleHide() {
        let searchButtonWrapper = document.getElementsByClassName('cearch_btn_wrapper')[0].getElementsByClassName("el-form-item__content")[0];
        this.show = !this.show;
        if (!this.show) {
          searchButtonWrapper.className = "el-form-item__content search_button_top";
        } else {
          searchButtonWrapper.className = "el-form-item__content";
        }

        setTimeout(() => {
          this.$emit('searchStatusChange');
          this.dispatch('layOut', 'isAsideOpen', [12]);
        }, 100);
      }
    }
  };

</script>

<style scoped lang='scss'>
  .up {
    width: -webkit-calc(100% - 150px);
    width: -moz-calc(100% - 150px);
    width: -o-calc(100% - 150px);
    width: calc(100% - 150px);
    overflow: hidden;
    height: 46px;
  }

  .hide_search {
    overflow-y: hidden;
    height: 74px;
    position: relative;
  }
  .search-content {
    width: 100%;
    overflow: hidden;
    background: rgba(249, 251, 253, 1);
    border-radius: 0px 6px 6px 0px;
    .g-flex__flex1 {
      position: relative;
    }
    .__main {
      background: #fff;
      border-right: 1px rgba(242, 243, 244, 1) solid;
      padding-top: 18px;
      flex: 1;
      /* padding-bottom: 12px; */

      .__btn-group {
        margin-right: 90px;
        margin-bottom: 30px;
      }

      button {
        margin: 0 auto;
      }
      .el-form-item__content {
        position: absolute !important;
        top: 0 !important;
        right: 20px !important;
      }
    }

    .__arrow {
      width: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      img {
        width: 16px;
        height: 10px;
        cursor: pointer;
      }
    }

    .noRotate {
      transform: rotate(180deg);
      transition: transform 0.1s;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/search-form/index.vue